export default __webpack_public_path__ + "static/media/pokrzywa.96e857f7.svg";